import { useQuery } from '@tanstack/react-query'
import { fetchReservations, FETCH_RESERVATIONS_KEY } from 'src/api/queries'
import { Reservation } from 'src/types/reservation'

const useGetReservations = (registryId: number | undefined) => {
  const reservationsQuery = useQuery({
    enabled: !!registryId,
    queryKey: [FETCH_RESERVATIONS_KEY, registryId],
    queryFn: () => fetchReservations(registryId),
  })
  let reservations: Reservation[] = []

  if (reservationsQuery.data) {
    reservations = Object.values(reservationsQuery.data)
  }

  return { reservations, reservationsQuery }
}

export default useGetReservations
